// extracted by mini-css-extract-plugin
export var navbarSubLink = "H_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "H_t4 d_f0 d_dB";
export var subPageLink = "H_gf d_gf";
export var burger = "H_wF";
export var sublinkSize = "H_wG";
export var linkSize = "H_wH";
export var Link = "H_rz p_rz p_qN p_q6";